<template>
  <div class="d-flex bar" :id="`bar_0${index}`"></div>
</template>

<script>
const MIN_WIDTH = 4
export default {
  props: {
    staffStartHour: {
      type: String,
    },
    staffStartMinute: {
      type: String,
    },
    staffEndHour: {
      type: String,
    },
    staffEndMinute: {
      type: String,
    },
    businessStartHour: {
      type: String,
    },
    businessStartMinute: {
      type: String,
    },
    businessEndHour: {
      type: String,
    },
    businessEndMinute: {
      type: String,
    },
    year: {
      type: Number,
    },
    month: {
      type: Number,
    },
    day: {
      type: Number,
    },
    index: {
      type: Number,
    },
  },
  data() {
    return {
      startHour: 8,
      startMinute: 0,
      endHour: 22,
      endMinute: 0,
    }
  },
  mounted() {
    this.$nextTick(() => {
      const startDiff = this.calculationDiff(
        this.businessStartHour,
        this.businessStartMinute,
        this.staffStartHour,
        this.staffStartMinute
      )
      if (startDiff < 0) {
        // 出勤時間が営業時間より早い時間のとき
        // 8時から出勤時間の差
        const diff01 = this.calculationDiff(
          this.startHour,
          this.startMinute,
          this.staffStartHour,
          this.staffStartMinute
        )
        this.createElement(diff01, 'gray')
      } else {
        // 8時から営業開始時間の差
        const diff01 = this.calculationDiff(
          this.startHour,
          this.startMinute,
          this.businessStartHour,
          this.businessStartMinute
        )
        this.createElement(diff01, 'gray')

        // 営業開始時間からスタッフ出勤時間の差
        const diff02 = this.calculationDiff(
          this.businessStartHour,
          this.businessStartMinute,
          this.staffStartHour,
          this.staffStartMinute
        )
        this.createElement(diff02, 'white')
      }

      // スタッフ出勤時間から退勤時間の差
      const diff03 = this.calculationDiff(
        this.staffStartHour,
        this.staffStartMinute,
        this.staffEndHour,
        this.staffEndMinute
      )
      this.createElement(diff03, 'blue')

      const endDiff = this.calculationDiff(
        this.staffEndHour,
        this.staffEndMinute,
        this.businessEndHour,
        this.businessEndMinute
      )
      if (endDiff < 0) {
        // 退勤時間が営業時間より遅い時間のとき
        // 退勤時間から22時の差
        const diff05 = this.calculationDiff(
          this.staffEndHour,
          this.staffEndMinute,
          this.endHour,
          this.endMinute
        )
        this.createElement(diff05, 'gray')
      } else {
        // スタッフ退勤時間から営業終了時間の差
        const diff04 = this.calculationDiff(
          this.staffEndHour,
          this.staffEndMinute,
          this.businessEndHour,
          this.businessEndMinute
        )
        this.createElement(diff04, 'white')

        // 営業終了時間から22時の差
        const diff05 = this.calculationDiff(
          this.businessEndHour,
          this.businessEndMinute,
          this.endHour,
          this.endMinute
        )
        this.createElement(diff05, 'gray')
      }
    })
  },
  methods: {
    calculationDiff(startHour, startMinute, endHour, endMinute) {
      const startTime = new Date(
        this.year,
        this.month,
        this.day,
        Number(startHour),
        Number(startMinute)
      )
      const endTime = new Date(
        this.year,
        this.month,
        this.day,
        Number(endHour),
        Number(endMinute)
      )

      const diff = endTime.getTime() - startTime.getTime()
      const minDiff = diff / (60 * 1000)

      return minDiff
    },
    createElement(minDiff, className) {
      const width = MIN_WIDTH * (minDiff / 5)

      const span = document.createElement('span')

      span.style.width = `${width}px`
      span.style.height = '35px'

      if (className === 'gray') {
        span.style.background = '#EBEDEF'
      }
      if (className === 'blue') {
        span.style.background = '#3acccc'
      }
      const element = document.getElementById(`bar_0${this.index}`)

      element.appendChild(span)
    },
  },
}
</script>

<style lang="scss" scoped>
.bar {
  display: inline-flex;
  align-items: center;
  margin-right: 18px;
  margin-top: 10px;
}
</style>
